import {createReducer} from 'redux-act';
import {GET_SUCCESS_MANAGER_SUCCESS} from './action';

const initialState = () => ({
  // The location the manager below belongs to.
  locationId: null,
  manager: null
});

const successManagerReducer = createReducer(
  {
    [GET_SUCCESS_MANAGER_SUCCESS]: (store, {locationId, manager}) => ({
      ...store,
      locationId,
      manager
    })
  },
  initialState()
);

export default successManagerReducer;
